var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PageTitle',{attrs:{"title":"Detalles del usuario"}})]},proxy:true},{key:"content",fn:function(){return [_c('DatosUsuario',{attrs:{"lista_id":_vm.lista_id,"user_id":_vm.user_id}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }